import "./ConfigurationGroupMonitoringEdit.html";
import "./ConfigurationGroupMonitoringEdit.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ConfigurationGroupMonitoringEditComponentController from "./ConfigurationGroupMonitoringEditComponentController";

import "../../../../Forms/EditInstructionWithContacts/EditInstructionWithContactsComponent";
import "../../../../Forms/EditNotificationSubscriptions/EditNotificationSubscriptionsComponent";
import "../../../../Forms/EditIssueSubscriptions/EditIssueSubscriptionsComponent";
import "../../../../Forms/EditARCIssueSubscriptions/EditARCIssueSubscriptionsComponent";

export default class ConfigurationGroupMonitoringEditComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = ConfigurationGroupMonitoringEditComponentController;
        this.templateUrl =
            "/App/Components/Site/ConfigurationGroups/Monitoring/Edit/ConfigurationGroupMonitoringEdit.html";
    }
}

module("mmManagePortal").component(
    "mmConfigurationGroupMonitoringEdit",
    new ConfigurationGroupMonitoringEditComponent(),
);
